import { useQuery } from "@tanstack/react-query";
import { getMobility } from "../api/mobility";
import { GetMobility } from "../types/types";

const useGetMobility = ({
  limit,
  page,
  searchKey,
  mobilityCode,
  area,
  sort,
  groupId,
  startDate,
  endDate,
  event_code,
}: GetMobility) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "Mobility",
      `page-${page}`,
      `searchKey-${searchKey}`,
      `mobilityCode-${mobilityCode}`,
      `area-${area}`,
      `sort-${sort}`,
      `limit-${limit}`,
      `groupId-${groupId}`,
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `event_code-${event_code}`,
    ],
    queryFn: () =>
      getMobility({
        limit,
        page,
        searchKey,
        mobilityCode,
        area,
        sort,
        groupId,
        startDate,
        endDate,
        event_code,
      }),

    retry: false,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return { data, isLoading, isSuccess };
};

export default useGetMobility;
